module.exports = __webpack_public_path__ + "static/media/ic_map.33d39b2b.svg";